import { useQuery } from 'react-query';

import auth from '@udacity/ureact-hoth';

import { useClientRender } from '~/hooks/use-client-render';

import { getLinkedAccounts } from '../controllers/get-user-linked-accounts';

/**
 * Determines whether the current learner authenticates via SSO (Okta) by
 * inspecting their linked accounts. Used to hide password/linked-account
 * settings that don't apply to SSO learners.
 */
export function useIsSsoLearner() {
  const isClient = useClientRender();
  const jwt = isClient ? auth.getJWT() : undefined;
  const userId = isClient ? auth.getCurrentUserId() : undefined;

  const isUserAuthenticated = Boolean(jwt) && Boolean(userId);

  const {
    data: linkedAccounts,
    isLoading: isSsoLearnerLoading,
    isFetched: isSsoLearnerFetched,
  } = useQuery('userLinkedAccounts', () => getLinkedAccounts({ jwt: jwt! }), {
    enabled: isUserAuthenticated,
  });

  return {
    isSsoLearner: linkedAccounts?.some((account) => account.toLowerCase() === 'okta'),
    isSsoLearnerLoading,
    isSsoLearnerFetched,
  };
}
